'use client'

import { useEffect } from 'react'
import { signOut, useSession } from 'next-auth/react'
import { usePathname, useRouter } from 'next/navigation'
import { navigateUrl } from '@/utils/client-request'

export function useLogoutFlow() {
  const { data: session } = useSession()
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    const performSignOut = async () => {
      try {
        if (!session?.user?.id) {
          router.push(navigateUrl('/login', pathname))
          return
        }
        await signOut({ redirect: false })
        const loginUrl = navigateUrl('/login', pathname)
        if (process.env.NEXT_PUBLIC_ENV === 'production') {
          const currentHost = window.location.host
          window.location.href = `${window.location.protocol}//${currentHost}${loginUrl}`
        } else {
          router.push(loginUrl)
        }
      } catch (error) {
        console.error('Error signing out:', error)
        router.push(navigateUrl('/login', pathname))
      }
    }
    performSignOut()
  }, [session, pathname, router])
}
